function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, CSSProperties, ReactNode, RefObject, MouseEventHandler } from 'react';
import cn from 'classnames';
require("./Link.css");
var styles = {
  "Root": "Link-module-Root_1TV",
  "defaultVariant": "Link-module-defaultVariant_143",
  "blackVariant": "Link-module-blackVariant_2QV",
  "successVariant": "Link-module-successVariant_3Qk",
  "warningVariant": "Link-module-warningVariant_8TB",
  "dangerVariant": "Link-module-dangerVariant_1Un",
  "dashedUnderline": "Link-module-dashedUnderline_3bo",
  "solidUnderline": "Link-module-solidUnderline_11l"
};
export const LinkVariants = {
  default: 'default',
  black: 'black',
  success: 'success',
  warning: 'warning',
  danger: 'danger'
};
export const LinkUnderlineVariants = {
  dashed: 'dashed',
  solid: 'solid'
};
export const LinkTags = {
  span: 'span',
  a: 'a',
  button: 'button'
};
export const Link = ({
  className,
  tag = LinkTags.a,
  href,
  rel,
  tabIndex,
  disabled,
  children,
  underline,
  target = '_self',
  variant = LinkVariants.default,
  innerRef,
  style = {},
  controlRef,
  ...props
}) => {
  const RootTag = tag;
  const rootProps = {
    ...props
  };
  if (tag === LinkTags.a) {
    rootProps.href = href;
    rootProps.rel = rel;
    rootProps.target = target;
    if (target === '_blank' && rel !== undefined) {
      // Пользовательский атрибут имеет больший приоритет
      rootProps.rel = `${rel} noopener`;
    }
    if (disabled) {
      rootProps.href = undefined;
      rootProps.role = 'link';
    }
  }
  if (tag === LinkTags.button) {
    rootProps.type = props.type || 'button';
  }
  return /*#__PURE__*/React.createElement(RootTag, _extends({}, rootProps, {
    ref: innerRef || controlRef,
    className: cn(styles.Root, styles[`${variant}Variant`], styles[`${underline}Underline`], className),
    style: style,
    "aria-disabled": disabled,
    tabIndex: disabled ? -1 : tabIndex
  }), children);
};
if (process.env.NODE_ENV !== 'production') {
  Link.displayName = 'Link';
}